export const isAuthenticated = (state) => {
  if (state.auth.auth.token) return true;
  return false;
};

export const selectIsSubAdmin = (state) => {
  if (state.auth?.auth.admin.role === "superAdmin") {
    return "superAdmin";
  } else if (state.auth?.auth.admin.role === "admin") {
    return "admin";
  } else {
    return "storeManagers";
  }

  return false;
};
